import React from "react";
import { render } from "react-dom";
//import DevTools from "mobx-react-devtools";

import registerServiceWorker from "./helpers/registerServiceWorker";
import "./assets/fonts/Gotham.css";
import "./assets/styles/App.css";
import App from "./components/App";
import stores from "./models/index";
import forms from './forms/_.forms';

import { Provider } from "mobx-react";
//import createBrowserHistory from 'history/createBrowserHistory';
import {
  BrowserRouter as Router,
  withRouter
} from 'react-router-dom';

//const browserHistory = createBrowserHistory();
const AppWrapper = withRouter(App);

render(
    <Provider {...stores} {...forms} >
    <Router >
      <AppWrapper/>
    </Router>
  </Provider>,
  document.getElementById("root")
);

// playing around in the console
window.stores = stores;

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js